module.exports = __webpack_public_path__ + "img/topAnswer.c794ca6f.svg";